import axiosInstance from '../utils/axiosInstance';

// ==================== Employees ====================
export const getEmployees = (params) => axiosInstance.get('/api/hrm/employees', { params });
export const getEmployee = (id, params) => axiosInstance.get(`/api/hrm/employees/${id}`, { params });
export const createEmployee = (data) => axiosInstance.post('/api/hrm/employees', data);
export const updateEmployee = (id, data) => axiosInstance.put(`/api/hrm/employees/${id}`, data);
export const deleteEmployee = (id, params) => axiosInstance.delete(`/api/hrm/employees/${id}`, { params });

// ==================== Departments ====================
export const getDepartments = (params) => axiosInstance.get('/api/hrm/departments', { params });
export const createDepartment = (data) => axiosInstance.post('/api/hrm/departments', data);
export const updateDepartment = (id, data) => axiosInstance.put(`/api/hrm/departments/${id}`, data);
export const deleteDepartment = (id, params) => axiosInstance.delete(`/api/hrm/departments/${id}`, { params });

// ==================== Positions ====================
export const getPositions = (params) => axiosInstance.get('/api/hrm/positions', { params });
export const createPosition = (data) => axiosInstance.post('/api/hrm/positions', data);
export const updatePosition = (id, data) => axiosInstance.put(`/api/hrm/positions/${id}`, data);
export const deletePosition = (id, params) => axiosInstance.delete(`/api/hrm/positions/${id}`, { params });

// ==================== Lifecycle Events ====================
export const getLifecycleEvents = (params) => axiosInstance.get('/api/hrm/lifecycle', { params });
export const createLifecycleEvent = (data) => axiosInstance.post('/api/hrm/lifecycle', data);

// ==================== Dashboard ====================
export const getHRMDashboard = (params) => axiosInstance.get('/api/hrm/dashboard', { params });

// ==================== Jobs ====================
export const getJobs = (params) => axiosInstance.get('/api/hrm/jobs', { params });
export const getJob = (id, params) => axiosInstance.get(`/api/hrm/jobs/${id}`, { params });
export const createJob = (data) => axiosInstance.post('/api/hrm/jobs', data);
export const updateJob = (id, data) => axiosInstance.put(`/api/hrm/jobs/${id}`, data);
export const deleteJob = (id, params) => axiosInstance.delete(`/api/hrm/jobs/${id}`, { params });

// ==================== Applicants ====================
export const getApplicants = (params) => axiosInstance.get('/api/hrm/applicants', { params });
export const getApplicant = (id, params) => axiosInstance.get(`/api/hrm/applicants/${id}`, { params });
export const createApplicant = (data) => axiosInstance.post('/api/hrm/applicants', data);
export const updateApplicant = (id, data) => axiosInstance.put(`/api/hrm/applicants/${id}`, data);
export const updateApplicantStatus = (id, data) => axiosInstance.put(`/api/hrm/applicants/${id}/status`, data);

// ==================== Interviews ====================
export const getInterviews = (params) => axiosInstance.get('/api/hrm/interviews', { params });
export const createInterview = (data) => axiosInstance.post('/api/hrm/interviews', data);
export const updateInterview = (id, data) => axiosInstance.put(`/api/hrm/interviews/${id}`, data);

// ==================== Offers ====================
export const getOffers = (params) => axiosInstance.get('/api/hrm/offers', { params });
export const createOffer = (data) => axiosInstance.post('/api/hrm/offers', data);
export const updateOffer = (id, data) => axiosInstance.put(`/api/hrm/offers/${id}`, data);

// ==================== Recruitment Dashboard ====================
export const getRecruitmentDashboard = (params) => axiosInstance.get('/api/hrm/recruitment/dashboard', { params });
